
<script>
import {Line, mixins} from "vue-chartjs";
const { reactiveProp } = mixins;
export default {
  extends: Line,
  mixins: [reactiveProp],
  props:{
    mainLabel: { type: String },
    labels: { type: Array },
    chartData: { type: Array },
    options: { type: Object }
  },
  mounted(){ 
    
    const data = {
      labels: this.labels,
      datasets: [{
        label: this.mainLabel,
        backgroundColor: 'teal',//'#f87979',
        data: this.chartData,
      }],
    };
    this.renderChart( data, this.options );
  }
}
</script>